<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_ship_designs', router)
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ship-designs')
})

const goToCommand = () => {
  router.push('/command/ship-designs')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.shipDesigns.blueprints') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.shipDesigns.applyNew') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.shipDesigns.canBuild') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.shipDesigns.whenReady') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.shipDesigns.buildColonizers') }}
      </p>

    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.shipDesigns.noNeedNow') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        {{ t('tutorial.shipDesigns.goToShipDesigns') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.shipDesigns.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>